import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';

import CopyInput from './CopyInput';
import { getEmbedUrl, getUrlWithParam } from '../../utils';
import {
    useDictionary,
    useMediaConfig,
    useLang,
    usePartnerId,
} from '../../hooks/config';

const Title = styled.label`
    margin-bottom: 5px;
    color: ${COLORS.mlbGrey3};
    font-family: ${FONTS.primaryFont};
    font-size: 10px;
    line-height: 1.6;
    text-transform: uppercase;
`;

const EmbedCode = ({
    lastModalNode,
    mediaPlayback,
    onShare,
}) => {

    const {
        embed_code_text: label = 'Embed Code',
    } = useDictionary();
    const config = useMediaConfig();
    const lang = useLang();
    const partnerId = usePartnerId();
    const src = getUrlWithParam(getEmbedUrl(mediaPlayback, config, lang), { partnerId });
    const width = config.shareConfig?.embedCode?.width ?? '560';
    const height = config.shareConfig?.embedCode?.height ?? '315';
    const code = `<iframe src="${src}" width="${width}" height="${height}"></iframe>`;

    return (
        <>
            <Title>{label}</Title>
            <CopyInput
                name={'Embed'}
                value={code}
                iconType={'embed'}
                ariaLabel={label}
                onClick={onShare}
                lastModalNode={lastModalNode}
            />
        </>
    );

};

EmbedCode.propTypes = {
    lastModalNode: PropTypes.object,
    mediaPlayback: PropTypes.object,
    onShare: PropTypes.func,
};

EmbedCode.defaultProps = {
    lastModalNode: undefined,
    mediaPlayback: {},
    onShare: _noop,
};

export default EmbedCode;
